require("@rails/ujs").start();
require("jquery");
require("bootstrap");
